import React from "react";
import { BgHeroProvide, BgHeroProvideRight } from "../../../assets";

const ProvideHero = () => {
  return (
    <div className="container-fluid providehero">
      <img className="leftsidebg" src={BgHeroProvide} alt="" />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p>The dream management software for </p>
            <p>children's activity and enrichment programs</p>
            <p>that seamlessly connects parents with educators</p>
            <p>
              <span>Discover your Dream Tools today!</span>{" "}
            </p>
          </div>
        </div>
      </div>
      <img className="rightsidebg" src={BgHeroProvideRight} alt="" />
    </div>
  );
};
export default ProvideHero;
